import React, { useState } from 'react';
import { Box } from 'wt-ui';
import PropTypes from 'prop-types';
import {
  CRYPTO_CLARIFIED,
  THE_COMMODITY_EXCHANGE,
  THE_NEXT_BIG_THING,
} from '../../services/Constants';
import './index.css';
import Chip from './Chip';
import Config from '../../services/Config';

const toLowerCase = (val) => (val ? val.toLowerCase() : '');

const defaultFT = Config.defaultFilterName;
const filters = {
  [THE_COMMODITY_EXCHANGE]: toLowerCase(defaultFT) === toLowerCase(THE_COMMODITY_EXCHANGE),
  [CRYPTO_CLARIFIED]: toLowerCase(defaultFT) === toLowerCase(CRYPTO_CLARIFIED),
  [THE_NEXT_BIG_THING]: toLowerCase(defaultFT) === toLowerCase(THE_NEXT_BIG_THING),
};
const shouldShowFilter = (filterType, podcasts) => podcasts.some(podcast => toLowerCase(podcast.podcastTitle).includes(toLowerCase(filterType)));

const Header = ({ setSelectedFilter, podcastList }) => {
  const [selectedFilters, setFilter] = useState(filters);

  const setSelectedFilterTitle = (title) => {
    selectedFilters[title] = !selectedFilters[title];
    setFilter(selectedFilters);
    const filterList = Object.keys(selectedFilters).filter(key => selectedFilters[key]);
    setSelectedFilter(filterList);
  };

  return (
    <Box
      background="transparent"
      direction="row-responsive"
      pad="medium"
      justify="end"
      align="center"
      gap="medium"
      round="medium"
      className="header"
      border={false}
    >
      <div className="filter-text">Filter By:</div>
      {shouldShowFilter(CRYPTO_CLARIFIED, podcastList) && (
      <Chip
        className="filter-item"
        title={CRYPTO_CLARIFIED}
        isSelected={selectedFilters[CRYPTO_CLARIFIED]}
        setSelectedFilter={setSelectedFilterTitle}
      />
      )}
      {shouldShowFilter(THE_COMMODITY_EXCHANGE, podcastList) && (
      <Chip
        lassName="filter-item"
        title={THE_COMMODITY_EXCHANGE}
        isSelected={selectedFilters[THE_COMMODITY_EXCHANGE]}
        setSelectedFilter={setSelectedFilterTitle}
      />
      )}
      {shouldShowFilter(THE_NEXT_BIG_THING, podcastList) && (
      <Chip
        lassName="filter-item"
        title={THE_NEXT_BIG_THING}
        isSelected={selectedFilters[THE_NEXT_BIG_THING]}
        setSelectedFilter={setSelectedFilterTitle}
      />
      )}
    </Box>
  );
};

Header.defaultProps = {
  podcastList: [],
};

Header.propTypes = {
  setSelectedFilter: PropTypes.func.isRequired,
  podcastList: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Header;
